<h2 *ngIf="idiomasAdicionales.length > 1" class="p-20" style="text-align:center;">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.TITULO' | translate}}</h2>
<h2 *ngIf="idiomasAdicionales.length == 0" class="p-20" style="text-align:center;">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.TITULOALTERNO' | translate}}</h2>
<mat-horizontal-stepper>

  <mat-step *ngFor="let traduccion of idiomasAdicionales; index as i;" label="{{'NOMBREIDIOMAS.'+traduccion.nombreIdioma | translate}}" state="idioma"
  [stepControl]="formGroups[i]" errorMessage="{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.NOTYET' | translate}}">

      <form [formGroup]="formGroups[i]" fxLayout="column" fxLayoutAlign="space-between stretch">
        <table *ngFor="let pregunta of textosPreguntasFiltrados; index as idxPreg;"
          fxLayout="column" fxLayoutAlign="space-between stretch"
          class="mat-card mat-elevation-z4 p-24 mt-12 mb-12">

          <tr fxLayout="row">
            <th fxFlex="50" class="accent-500 p-20">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.MAIN' | translate}}</th>
            <th fxFlex="50" class="accent-100 p-20">{{'NOMBREIDIOMAS.'+traduccion.nombreIdioma | translate}}</th>
          </tr>
          <!---texto de la pregunta-->
          <tr fxLayout="row" fxLayoutAlign="space-between stretch">

            <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch" class="p-20">
              <h3>{{pregunta.textoPregunta}}</h3>
            </td>

            <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">

              <mat-form-field appearance="outline">
                <mat-label>{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.INPUT.NEW' | translate}}</mat-label>
                <textarea matInput required
                *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) != -1
                && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)]
                && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg]"
                [(ngModel)]="textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].textoPregunta"
                name="texto{{idxPreg}}"
                formControlName="texto{{idxPreg}}"
                (blur)="guardaTraduccion($event, pregunta, traduccion._id, 'texto'+idxPreg, textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].idAdicionalInterna)"
                ></textarea>

                <textarea matInput required
                *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) != -1
                && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)]
                && !textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg]"
                name="texto{{idxPreg}}"
                formControlName="texto{{idxPreg}}"
                (blur)="guardaTraduccion($event, pregunta, traduccion._id, 'texto'+idxPreg)"
                ></textarea>

                <textarea matInput required
                *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) == -1"
                name="texto{{idxPreg}}"
                formControlName="texto{{idxPreg}}"
                (blur)="guardaTraduccion($event, pregunta, traduccion._id, 'texto'+idxPreg)"
                ></textarea>
                <mat-error>{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.INPUT.ERROR' | translate}}</mat-error>
              </mat-form-field>

            </td>

          </tr>
          <!--opciones de respuesta-->

          <ng-container  *ngIf="pregunta.tipoPregunta != '1'" >

            <tr *ngFor="let opcion of pregunta.opcionesResp; index as idxOpc;"
            fxLayout="row" fxLayoutAlign="space-between stretch">

              <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch" class="p-20">
                <h3>{{opcion.textoOpcion}}</h3>
              </td>

              <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">

                <mat-form-field appearance="outline">
                  <mat-label>{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.INPUT.NEWOPC' | translate}}</mat-label>

                  <textarea matInput required
                  *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) != -1
                  && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)]
                  && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg]
                  && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].opcionesResp[idxOpc]"
                  [(ngModel)]="textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].opcionesResp[idxOpc].textoOpcion"
                  name="texto{{idxPreg}}Opc{{idxOpc}}"
                  formControlName="texto{{idxPreg}}Opc{{idxOpc}}"
                  (blur)="guardaTraduccionOpcion($event, pregunta, traduccion._id, idxPreg, idxOpc, opcion,
                  textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].opcionesResp[idxOpc].idAdicionalOpcion,
                  textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].idAdicionalInterna)"
                  ></textarea>

                  <textarea matInput required
                  *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) != -1
                  && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)]
                  && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg]
                  && !textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].opcionesResp[idxOpc]"
                  name="texto{{idxPreg}}Opc{{idxOpc}}"
                  formControlName="texto{{idxPreg}}Opc{{idxOpc}}"
                  (blur)="guardaTraduccionOpcion($event, pregunta, traduccion._id, idxPreg, idxOpc, opcion, null,
                  textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg].idAdicionalInterna)"
                  ></textarea>

                  <textarea matInput required
                  *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) != -1
                  && textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)]
                  && !textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)][idxPreg]"
                  name="texto{{idxPreg}}Opc{{idxOpc}}"
                  formControlName="texto{{idxPreg}}Opc{{idxOpc}}"
                  (blur)="guardaTraduccionOpcion($event, pregunta, traduccion._id, idxPreg, idxOpc, opcion)"
                  ></textarea>

                  <textarea matInput required
                  *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) != -1
                  && !textosPreguntasRestoIdiomas[nombreIdiomaAdicional.indexOf(traduccion._id)]"
                  name="texto{{idxPreg}}Opc{{idxOpc}}"
                  formControlName="texto{{idxPreg}}Opc{{idxOpc}}"
                  (blur)="guardaTraduccionOpcion($event, pregunta, traduccion._id, idxPreg, idxOpc, opcion)"
                  ></textarea>

                  <textarea matInput required
                  *ngIf="nombreIdiomaAdicional.indexOf(traduccion._id) == -1"
                  name="texto{{idxPreg}}Opc{{idxOpc}}"
                  formControlName="texto{{idxPreg}}Opc{{idxOpc}}"
                  (blur)="guardaTraduccionOpcion($event, pregunta, traduccion._id, idxPreg, idxOpc, opcion)"
                  ></textarea>



                  <mat-error>{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.INPUT.ERROROPC' | translate}}</mat-error>
                </mat-form-field>

              </td>

            </tr>

          </ng-container>

          <tr fxLayout="row" fxLayoutAlign="end none" *ngIf="formGroups[i].valid" >
            <th colspan="2">{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.COMPLETE' | translate}}<mat-icon>check_circle_outline</mat-icon></th>
          </tr>

        </table>

        <!-- <p>Put down your phones.</p>
        <input matInput placeholder="Last name, First name" formControlName="control1" required>
        <input matInput placeholder="Last name, First name" formControlName="control2" required>
        <input matInput placeholder="Last name, First name" formControlName="control3" required>
        <input matInput placeholder="Last name, First name" formControlName="control4" required>
        <input matInput placeholder="Last name, First name" formControlName="control5" required> -->
      </form>

  </mat-step>


  <!-- Icon overrides. -->
  <ng-template matStepperIcon="idioma">
    <mat-icon>language</mat-icon>
  </ng-template>
</mat-horizontal-stepper>
